import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const CheckboxOn: FunctionalComponent<IIconProps> = ({ width = '20', height = '20', fill = '#666' }) => {
  return (
    /*@ts-ignore*/
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20">
      <rect width="20" height="20" fill={fill} rx="4" />
      <path
        fill="#fff"
        fill-rule="evenodd"
        stroke="#fff"
        d="M7.299 14.666l-.071-.008-.086-.02c-.044-.012-.087-.03-.128-.053l-.07-.044-.016-.012c-.023-.018-.045-.037-.066-.058l-.03-.031-2.686-3.357c-.23-.287-.183-.707.104-.937.266-.212.644-.189.881.042l.056.062 2.201 2.751 7.474-7.472c.24-.24.618-.26.88-.056l.063.056c.24.24.259.618.055.88l-.055.062-8.022 8.021-.057.047-.048.032c-.034.02-.07.038-.106.052-.038.014-.077.025-.116.032l-.083.01h-.079.005z"
        clip-rule="evenodd"
      />
    </svg>
  );
};

export default CheckboxOn;
